// extracted by mini-css-extract-plugin
export default {"page":"pB","headerblock":"qB","text":"rB","toptext":"sB","ingredientswrapper":"tB","buttonwrapper":"uB"};
    if(module.hot) {
      // 1713211520696
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  